import React, { Dispatch, Fragment, SetStateAction, useContext } from 'react';
import { Link } from 'react-router-dom';
import cc from 'classnames';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { AuthContext } from '@ryanar/react-auth-provider';
import { socialLinks } from 'utils/constants';
import noop from 'utils/noop';
import { SideMenuOptionsType } from '../sideMenuOptions';

import styles from './MobileSideMenu.module.css';

import instagram from 'assets/icons/instagram-grey.svg';
import linkedin from 'assets/icons/linkedin-grey.svg';
import facebook from 'assets/icons/facebook-grey.svg';
import twitter from 'assets/icons/twitter-grey.svg';

interface IMobileSideMenu {
  items: SideMenuOptionsType[];
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  menuClassName?: string;
  onClick?: () => void;
}

const MobileSideMenu = ({ items, isOpen, setOpen, menuClassName, onClick }: IMobileSideMenu) => {
  const handleOnClick = (open: boolean) => () => setOpen(open);

  const renderItem = ({ icon, iconAlt, name, link }: SideMenuOptionsType) => {
    const content = (
      <ListItem key={name} button onClick={name === 'Log Out' ? onClick : noop}>
        <ListItemIcon>
          <img src={icon} alt={iconAlt} />
        </ListItemIcon>
        <ListItemText>{name}</ListItemText>
      </ListItem>
    );

    return link ? (
      <Fragment key={name}>
        <Link to={link} className={styles.link}>
          {content}
        </Link>
        <Divider />
      </Fragment>
    ) : (
      <Fragment key={name}>
        {content}
        <Divider />
      </Fragment>
    );
  };

  const socialLinksJSX = (
    <div style={{ padding: 20 }}>
      <div className={styles.socialLinksWrapper}>
        <a href={socialLinks.facebook} className={styles.socialLink} target="_blank" rel="noreferrer">
          <img src={facebook} alt="facebook" className={styles.socialIcon} />
        </a>
        <a href={socialLinks.twitter} className={styles.socialLink} target="_blank" rel="noreferrer">
          <img src={twitter} alt="twitter" className={styles.socialIcon} />
        </a>
        <a href={socialLinks.instagram} className={styles.socialLink} target="_blank" rel="noreferrer">
          <img src={instagram} alt="instagram" className={styles.socialIcon} />
        </a>
        <a href={socialLinks.linkedin} className={styles.socialLink} target="_blank" rel="noreferrer">
          <img src={linkedin} alt="linkedin" className={styles.socialIcon} />
        </a>
      </div>

      <div>
        <span className={cc(styles.socialLink, styles.socialText)}>@firstatlanticgh</span>
      </div>
    </div>
  );

  const { authenticated } = useContext(AuthContext);

  const renderList = () => (
    <div className={styles.container} role="presentation" onClick={handleOnClick(false)}>
      <List>
        <Divider />
        {items.map(renderItem)}
      </List>
      {!authenticated && socialLinksJSX}
    </div>
  );

  return (
    <SwipeableDrawer
      anchor="right"
      open={isOpen}
      onClose={handleOnClick(false)}
      onOpen={handleOnClick(true)}
      className={cc(styles.menu, menuClassName)}
    >
      {renderList()}
    </SwipeableDrawer>
  );
};

export default MobileSideMenu;
